<div
    class="tabs-holder"
>
    <div class="tabs-list">
        <span
            class="tab-item tab-login"
            (click)="changeScreen('login')"
            [ngClass]="{ active: screen === 'login' }"
        >
            <span *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.sign_in_label ? moduleAuthTexts.sign_in_label : 'Log in' }}</span>
        </span>
        <span
            class="tab-item tab-register"
            (click)="changeScreen('create-account')"
            [ngClass]="{ active: screen === 'create-account' }"
        >
            <span *ngIf="moduleAuthTexts$ | async as moduleAuthTexts">{{ moduleAuthTexts.sign_up_label ? moduleAuthTexts.sign_up_label : 'Sign up' }}</span>
        </span>
        <div class="tab-indicator"></div>
    </div>
</div>
